// import Image from '@ui/image'
import TeamMember from '@components/team-member'
import { Container, Row, Col } from '@ui/wrapper'
import SectionTitle from '@ui/section-title'
import {
  BoxImgWrapper,
  BoxImgInner
  // BoxImgMedia,
  // BoxImgContent,
  // BoxImgText,
  // Break,
  // HeadingWrap,
  // TextWrap
} from './style'

const BoxImage = ({
  children,
  images,
  texts,
  title,
  className,
  ...restProps
}) => {
  return (
    <BoxImgWrapper className={className} {...restProps}>
      <BoxImgInner>
        <Container>
          <Row
            className="justify-content-center d-flex"
            style={{ margin: '0 -15px' }}
          >
            {title && (
              <SectionTitle
                mb={
                  images !== null
                    ? ['45px', null, null, '70px']
                    : ['25px', null, null, '40px']
                }
                subtitle=""
                title={title}
              />
            )}
            {images?.map((image, i) => (
              <Col
                md={4}
                key={i}
                mb="30px"
                style={{
                  paddingLeft: '50px',
                  paddingRight: '50px',
                  paddingBottom: '10px'
                }}
              >
                <TeamMember
                  layout={2}
                  image={image}
                  name={
                    texts[i].content
                      .split('<br>')[0]
                      .replace('<b>', '')
                      .replace('</b>', '')
                      .split('(')[0] +
                    '<br>(' +
                    texts[i].content
                      .split('<br>')[0]
                      .replace('<b>', '')
                      .replace('</b>', '')
                      .split('(')[1]
                  }
                  designation={texts[i].content
                    .split('<br>')
                    .slice(1)
                    .join('<br>')}
                />
              </Col>
            ))}
            {!images && (
              <div
                className="justify-content-center d-flex"
                style={{ paddingLeft: '50px' }}
              >
                {children}
              </div>
            )}
          </Row>
        </Container>
      </BoxImgInner>
    </BoxImgWrapper>
  )
}

export default BoxImage
